export const OverviewTrackingEvents = {
  ADAC: {
    OVERVIEW_VISITED: { page: 'adac.overview' },
  },
  OPPORTUNITY_CHECK: {
    OVERVIEW_VISITED: { page: 'competetion_analysis.overview' },
    HOW_IT_WORKS_VISITED: { page: 'competetion_analysis.how_it_works' },
    FAQ_VISITED: { page: 'competetion_analysis.faqs' },
  },
  EXCLUSIVE_LISTINGS: {
    OVERVIEW_VISITED: { page: 'exclusive_listings.overview' },
    FAQ_VISITED: { page: 'exclusive_listings.faqs' },
  },
  FIRST_IN_INBOX: {
    OVERVIEW_VISITED: { page: 'contact_at_top.overview' },
    FAQ_VISITED: { page: 'contact_at_top.faqs' },
  },
  MESSENGER: {
    OVERVIEW_VISITED: { page: 'contact_at_top.overview' },
  },
  ADVERTISEMENTS: {
    OVERVIEW_VISITED: { page: 'exclusive_listings.overview' },
  },
  SCHUFA: {
    OVERVIEW_VISITED: { page: 'solvency_check.overview' },
    HOW_IT_WORKS_VISITED: { page: 'solvency_check.how_it_works' },
  },
  POSSIBLITY_CHECK: {
    OVERVIEW_VISITED: { page: 'competition_analysis.overview' },
    HOW_IT_WORKS_VISITED: { page: 'competition_analysis.how_it_works' },
  },
  SCHUFA_CHECK: {
    OVERVIEW_VISITED: { page: 'solvency_check.overview' },
    HOW_IT_WORKS_VISITED: { page: 'solvency_check.how_it_works' },
    FAQ_VISITED: { page: 'solvency_check.faqs' },
  },
  APPLICATION_PACKAGE: {
    OVERVIEW_VISITED: { page: 'application_package.overview' },
    HOW_IT_WORKS_VISITED: { page: 'application_package.how_it_works' },
    FAQ_VISITED: { page: 'application_package.faqs' },
  },
  VALUATION: {
    OVERVIEW_VISITED: { page: 'valuation.overview' },
    HOW_IT_WORKS_VISITED: { page: 'valuation.how_it_works' },
    FAQ_VISITED: { page: 'valuation.faqs' },
    OVERVIEW_CLICKED: { page: 'valuation_plus', label: 'valuation_overview' },
    WIZARD_CLICKED: { page: 'valuation_plus', label: 'valuation' },
  },
  REAL_ESTATE_PROOF: {
    OVERVIEW_VISITED: { page: 'property_proof.overview' },
    HOW_IT_WORKS_VISITED: { page: 'property_proof.how_it_works' },
    FAQ_VISITED: { page: 'property_proof.faqs' },
  },
  REAL_ESTATE_DAMAGE_REPORT: {
    OVERVIEW_VISITED: { page: 'damage_report.overview' },
    HOW_IT_WORKS_VISITED: { page: 'damage_report.how_it_works' },
    FAQ_VISITED: { page: 'damage_report.faqs' },
  },
  LEGAL_INSURANCE: {
    OVERVIEW_VISITED: { page: 'legal_insurance.overview' },
    HOW_IT_WORKS_VISITED: { page: 'legal_insurance.how_it_works' },
    FAQ_VISITED: { page: 'legal_insurance.faqs' },
  },
  TENANT_PROTECTION_SERVICE: {
    LINK_CLICKED: {
      page: 'tenant_protection',
      action: 'profile',
      label: 'tenant_protection_clickout',
      name: 'benefit_clickout',
      product: 'plus',
      parameter1: 'living',
      parameter2: 'tenant_protection',
    },
    OVERVIEW_VISITED: { page: 'tenant_protection.overview' },
    HOW_IT_WORKS_VISITED: { page: 'tenant_protection.how_it_works' },
    FAQ_VISITED: { page: 'tenant_protection.faqs' },
  },
  DOCUMENTS: {
    OVERVIEW_VISITED: { page: 'application_package.overview' },
    HOW_IT_WORKS_VISITED: { page: 'application_package.how_it_works' },
  },
  STORAGE_SERVICE: {
    FORM_VISITED: { page: 'lagerbox.funnel.success' },
    FUNNEL_SUCCESS: {
      page: 'lagerbox.funnel.success',
      action: 'profile',
      label: 'lagerbox_request',
      name: 'benefit_request',
      product: 'plus',
      parameter1: 'living',
      parameter2: 'lagerbox',
    },
    OVERVIEW_VISITED: { page: 'lagerbox.overview' },
    HOW_IT_WORKS_VISITED: { page: 'lagerbox.how_it_works' },
    FAQ_VISITED: { page: 'lagerbox.faqs' },
  },
  DEPOSIT: {
    OVERVIEW_VISITED: { page: 'deposit.overview' },
    HOW_IT_WORKS_VISITED: { page: 'deposit.how_it_works' },
    FAQ_VISITED: { page: 'deposit.faqs' },
  },
  KEY_EMERGENCY: {
    FORM_VISITED: { page: 'key_service.funnel.submit' },
    FUNNEL_CANCELLATION: {
      page: 'key_service.funnel.cancellation',
      category: 'conmon',
      label: 'legaladvice_cancel',
    },
    FUNNEL_SUBMIT: {
      page: 'key_service.funnel.submit',
      category: 'conmon',
      action: 'profile',
      label: 'keyservice_request',
      name: 'benefit_request',
      product: 'plus',
      parameter1: 'living',
      parameter2: 'key_service',
    },
    FUNNEL_MODIFY: {
      page: 'key_service.funnel.modify',
    },
    OVERVIEW_VISITED: { page: 'key_service.overview' },
    HOW_IT_WORKS_VISITED: { page: 'key_service.how_it_works' },
  },
  RENT_LEGAL: {
    FORM_VISITED: { page: 'legal_advice.funnel.submit' },
    FUNNEL_CANCELLATION: {
      page: 'legal_advice.funnel.cancellation',
      category: 'conmon',
      label: 'legaladvice_cancel',
    },
    FUNNEL_SUBMIT: {
      page: 'legal_advice.funnel.submit',
      category: 'conmon',
      action: 'profile',
      label: 'legaladvice_request',
      name: 'benefit_request',
      product: 'plus',
      parameter1: 'living',
      parameter2: 'legal_advice',
    },
    FUNNEL_MODIFY: {
      page: 'legal_advice.funnel.modify',
    },
    OVERVIEW_VISITED: { page: 'legal_advice.overview' },
    HOW_IT_WORKS_VISITED: { page: 'legal_advice.how_it_works' },
  },
  RELOCATION_SERVICE: {
    OVERVIEW_VISITED: { page: 'relocation.overview' },
    HOW_IT_WORKS_VISITED: { page: 'relocationt.how_it_works' },
    FAQ_VISITED: { page: 'relocation.faqs' },
    FUNNEL_SUBMIT: {
      page: 'relocation',
      category: 'conmon',
      action: 'profile',
      label: 'profile',
      name: 'benefit_clickout',
      product: 'plus',
      parameter1: 'rent',
      parameter2: 'relocation',
    },
  },
  BILLCHECK: {
    OVERVIEW_VISITED: { page: 'utilitybill_check.overview' },
    HOW_IT_WORKS_VISITED: { page: 'utilitybill_check.how_it_works' },
    CREATION_FLOW: {
      CUSTOMER_DETAILS: { page: 'utilitybill_check.funnel.customer_details' },
      BALANCE_DETAILS: { page: 'utilitybill_check.funnel.balance_details' },
      ACCOUNTING_PERIOD_DETAILS: { page: 'utilitybill_check.funnel.accounting_period_details' },
      OPERATIONAL_STATEMENT_UPLOAD: { page: 'utilitybill_check.funnel.operational_statement_upload' },
      RENTAL_CONTRACT_UPLOAD: { page: 'utilitybill_check.funnel.rental_contract_upload' },
      SUBMISSION: {
        page: 'utilitybill_check',
        action: 'profile',
        label: 'utilitybill_check_request',
        category: 'conmon',
        name: 'benefit_request',
        product: 'plus',
        parameter1: 'living',
        parameter2: 'utilitybill_check',
      },
    },
  },
  MAGENTA_TV: {
    OVERVIEW_VISITED: { page: 'magenta_tv.overview' },
    HOW_IT_WORKS_VISITED: { page: 'magenta_tv.how_it_works' },
    FAQ_VISITED: { page: 'magenta_tv.faqs' },
    TERMS_VISITED: { page: 'magenta_tv.terms' },
    DISCOUNT_CODE_SEEN: { page: 'magenta_tv.code' },
    DISCOUNT_CODE_REDEEM: {
      page: 'magenta_tv.code',
      action: 'click_redeem_discount_code',
      label: 'redeem_discount_code',
      name: 'benefit_clickout',
      product: 'plus',
      parameter1: 'rent', // rent as default, but should be overwritten dynamically by product in usage
      parameter2: 'magenta_tv',
    },
  },
  MIETER_NETZWERK: {
    OVERVIEW_VISITED: { page: 'tenant_network.overview' },
    FUNNEL_SUBMIT: {
      page: 'tenant_network',
      category: 'conmon',
      action: 'profile',
      label: 'profile',
      name: 'benefit_clickout',
      product: 'plus',
    },
  },
  WARTELISTE: {
    OVERVIEW_VISITED: { page: 'waitinglist.overview' },
    LINK_CLICKED: {
      page: 'waitinglist.overview',
      action: 'profile',
      label: 'waitinglist_clickout',
      name: 'benefit_clickout',
      product: 'plus',
      parameter1: 'rent',
      parameter2: 'waitinglist',
    },
  },
  AUTO_CONTACT_AGENT: {
    OVERVIEW_VISITED: { page: 'auto_contact_assistant.overview' },
  },
  GREEN_ELECTRICITY: {
    OVERVIEW_VISITED: { page: 'klarwatt.overview' },
  },
} as const;

export const TrackingEvents = {
  TENANT: {
    PAGE_VISITED: {
      page: '',
    },
    RENTAL_CONTRACT_CANCEL: {
      page: 'detail.tenant',
      name: 'create_cancellation_click',
      product: 'property_hub',
    },
    DOCUMENT_OPENED: {
      page: 'document',
    },
    DOCUMENT_CLICKED: {
      page: 'document',
      name: 'upload_document_click',
      product: 'property_hub',
    },
    DOCUMENT_UPLOADED: {
      page: 'document',
      name: 'upload_document_success',
      product: 'property_hub',
    },
    DOCUMENT_DELETED: {
      page: 'document',
      name: 'delete_document_click',
      product: 'property_hub',
    },
    DOCUMENT_DOWNLOADED: {
      page: 'document',
      name: 'download_document_click',
      product: 'property_hub',
    },
    DOCUMENT_SAVED: {
      page: 'document',
      name: 'save_document_click',
      product: 'property_hub',
    },
    DOCUMENT_PREVIEWED: {
      page: 'document',
      name: 'preview_document_click',
      product: 'property_hub',
    },
    DISCOVER_WOHNEN: {
      name: 'wohnenplus_click',
      product: 'property_hub',
    },
  },
  LAYOUT: {
    page: '',
  },
  INSURANCE_TIP: {
    page: 'lagerbox.funnel.success',
    TIP_CLICKED: {
      label: 'insurance_tip_clicked',
      action: 'vorteile_buy',
      category: 'conmon',
      name: 'promo_click',
      product: 'plus',
      parameter1: 'buy',
      parameter2: 'legal_insurance',
    },
    TIP_CLOSED: {
      label: 'insurance_tip_closed',
      category: 'conmon',
      action: 'vorteile_buy',
      name: 'promo_close',
      product: 'plus',
      parameter1: 'buy',
      parameter2: 'legal_insurance',
    },
  },
  SCHLUESSELDIENST: {
    OVERVIEW_VISITED: { page: 'key_service.overview' },
    HOW_IT_WORKS_VISITED: { page: 'key_service.how_it_works' },
    FUNNEL_MODIFY: {
      page: 'key_service.funnel.modify',
    },
  },
  RECHTSBERATUNG: {
    OVERVIEW_VISITED: { page: 'legal_advice.overview' },
    HOW_IT_WORKS_VISITED: { page: 'legal_advice.how_it_works' },
    FUNNEL_MODIFY: {
      page: 'legal_advice.funnel.modify',
    },
  },
  MEDIATION: {
    OVERVIEW_VISITED: { page: 'mediation.overview' },
    HOW_IT_WORKS_VISITED: { page: 'mediation.how_it_works' },
    FUNNEL_MODIFY: {
      page: 'mediation.funnel.modify',
    },
  },
  MIETRECHTSSCHUTZ: {
    OVERVIEW_VISITED: { page: 'legal_insurance.overview' },
    HOW_IT_WORKS_VISITED: { page: 'legal_insurance.how_it_works' },
    FUNNEL_MODIFY: {
      page: 'legal_insurance.funnel.modify',
    },
  },
  WOHNEN_PLUS_LIGHT: {
    PAGE_VISITED: { page: 'wohnenplus_light' },
    SUCCESS: { page: 'wohnenplus_light.success' },
    MODAL_CLOSE_X: {
      page: 'wohnenplus_light',
      name: 'modal_close',
      product: 'plus',
      parameter1: 'living',
      parameter2: 'top_x',
    },
    MODAL_CLOSE_REFRAIN: {
      page: 'wohnenplus_light',
      name: 'modal_close',
      product: 'plus',
      parameter1: 'living',
      parameter2: 'bottom_refrain',
    },
    SUBSCRIPTION_SALE: {
      page: 'wohnenplus_light',
      name: 'subscription_sale',
      product: 'plus',
      parameter1: 'living',
      parameter2: 'sp1m_ip12m',
      parameter3: 'savedpayment',
      parameter4: '1,99',
    },
    PROMO_CLICK_BOTTOM: {
      name: 'promo_click',
      product: 'plus',
      parameter1: 'living',
      parameter2: 'bottom',
    },
    PROMO_CLICK_BOTTOM_LIGHT: {
      name: 'promo_click',
      product: 'plus',
      parameter1: 'living',
      parameter2: 'bottom_light',
    },
    PROMO_CLICK_TOP_LIGHT: {
      name: 'promo_click',
      product: 'plus',
      parameter1: 'living',
      parameter2: 'top_light',
    },
  },
  WOHNEN_PLUS_UPSELL: {
    PAGE_VISITED: { page: 'wohnenplus_upsell' },
    OPTION_CLIKED: {
      name: 'option_click',
      product: 'plus',
      parameter1: 'living',
    },
  },
  ADAC_UPSELL: {
    PAGE_VISITED: { page: 'wohnenplus_adac_upsell' },
    OPTION_CLICKED: {
      page: 'wohnenplus_adac_upsell',
      label: 'option_click',
      name: 'option_click',
      product: 'plus',
      parameter1: 'living',
    },
    LEARN_MORE_CLICKED: {
      page: 'wohnenplus_adac_upsell',
      label: 'learn_more_click',
      name: 'learn_more_click',
      product: 'plus',
      parameter1: 'living',
    },
    CONTINUE_TO_PAYMENT_CLICKED: {
      page: 'wohnenplus_adac_upsell',
      label: 'continue_to_payment_click',
      name: 'continue_to_payment_click',
      product: 'plus',
      parameter1: 'living',
    },
    MODAL_CLOSE: {
      page: 'wohnenplus_adac_upsell',
      label: 'modal_close',
      name: 'modal_close',
      product: 'plus',
      parameter1: 'living',
    },
  },
  TENANT_WOHNEN_PLUS_UPSELL: {
    PAGE_VISITED: { page: 'wohnenplus_upsell' },
    OPTION_CLIKED: {
      page: 'wohnenplus_upsell',
      name: 'option_click',
    },
  },
  LIVING_UPSELL_VISITED: {
    page: 'welcome_overlay',
  },
  ADDRESS_CHANGE: {
    IFRAME: {
      page: 'fino',
    },
    OVERVIEW_VISITED: { page: 'address_change.overview' },
    LINK_CLICKED: {
      name: 'address_change',
      product: 'plus',
      parameter1: 'rent',
    },
  },
  WOMENS_DAY: {
    PAGE_VISITED: { page: 'international_women_day' },
    VOUCHER_GET: {
      page: 'international_women_day',
      label: 'voucher_get',
      name: 'voucher_get',
      product: 'plus',
      parameter1: 'living',
    },
    VOUCHER_SHARE: {
      page: 'international_women_day',
      label: 'voucher_share',
      name: 'voucher_share',
      product: 'plus',
      parameter1: 'rent',
    },
    VOUCHER_CLOSE: {
      page: 'international_women_day',
      label: 'voucher_close',
      name: 'voucher_close',
      product: 'plus',
      parameter1: 'living',
    },
  },
  ...OverviewTrackingEvents,
} as const;
